import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import store from "./Redux/store";
import axios from "axios";

// axios.defaults.baseURL = "https://climax.azurewebsites.net/api/";
// axios.defaults.baseURL = "http://54.162.189.211/";
axios.defaults.baseURL = "https://api.climaxdigitizing.net"

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

